import { render, staticRenderFns } from "./ActivityView.vue?vue&type=template&id=4d48abae&"
import script from "./ActivityView.vue?vue&type=script&lang=js&"
export * from "./ActivityView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports